/* eslint-disable @typescript-eslint/no-explicit-any */
import type { AgentInboxListMessagesParams } from '../api'
import userOtcService from './agent-inbox.service'
import { EAgentInboxQueryKey } from './agent-inbox.types'

export const agentInboxListMessagesOptionsPre = (
  params: AgentInboxListMessagesParams,
) => ({
  queryKey: [EAgentInboxQueryKey.AGENT_INBOX_LIST_MESSAGES, params],
  queryFn: ({ pageParam = 0 }) =>
    userOtcService.agentInboxListMessages({
      ...params,
      skip: pageParam * (params.limit || 10),
    }),
  staleTime: 1,
  getNextPageParam: (lastPage: any, allPages: any) => {
    const total = lastPage.data?.total
    const messages = lastPage.data?.messages || []
    const limit = params.limit || 10

    // If we have total count, use it for pagination
    if (total !== undefined && total !== null) {
      const currentLength = allPages.reduce(
        (acc: number, page: any) => acc + (page.data?.messages?.length || 0),
        0,
      )
      return currentLength < total ? allPages.length : undefined
    }

    // Fallback: If no total, check if we got fewer messages than requested
    // This indicates we've reached the end
    if (messages.length < limit) {
      return undefined
    }

    // If we got exactly the limit, there might be more data
    return allPages.length
  },
  initialPageParam: 0,
})
